import { render, staticRenderFns } from "./StockportCity.vue?vue&type=template&id=2be9de78&scoped=true&"
import script from "./StockportCity.vue?vue&type=script&lang=js&"
export * from "./StockportCity.vue?vue&type=script&lang=js&"
import style0 from "./StockportCity.vue?vue&type=style&index=0&id=2be9de78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9de78",
  null
  
)

export default component.exports